import Swiper from "swiper";
import { Pagination, Autoplay } from "swiper/modules";

export const initCategoriesSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".categories-slider__swiper",
  );

  sliders.forEach((el) => {
    if (el.dataset.initialized === "true") return;
    el.dataset.initialized = "true";

    const slideCount = el.querySelectorAll(".swiper-slide").length;
    const enableLoop = slideCount > 4;

    // Strict local selector queries
    const paginationEl = el.querySelector<HTMLElement>(
      ".categories-slider__pagination",
    );

    new Swiper(el, {
      modules: [Pagination, Autoplay],
      observer: true,
      observeParents: true,
      slidesPerView: 2,
      spaceBetween: 20,
      loop: enableLoop,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        640: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
      },
    });
  });
};
